var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var NetworkError = /** @class */ (function (_super) {
    __extends(NetworkError, _super);
    function NetworkError(statusCode, statusText) {
        var _this = this;
        if (!statusText) {
            statusText = 'Network Error';
        }
        var msg = "".concat(statusCode, " ").concat(statusText);
        _this = _super.call(this, msg) || this;
        _this.status = statusCode;
        _this.statusText = statusText;
        return _this;
    }
    NetworkError.isClientError = function (err) {
        if (err instanceof NetworkError) {
            return ((err.statusText === 'Network Error' ||
                err.statusText === 'Request aborted') &&
                err.status === 0);
        }
        return false;
    };
    return NetworkError;
}(Error));
export { NetworkError };
export function wrapReject(reject, defaultReason) {
    return function (e) {
        if (!e) {
            var reason = new Error(defaultReason);
            reject(reason);
        }
        reject(e);
    };
}
export function makeRequest(method, url, respType, headers, data) {
    return new Promise(function (resolve, reject) {
        var xhr = new XMLHttpRequest();
        xhr.open(method, url);
        try {
            xhr.responseType = respType;
        }
        catch (_a) {
            xhr.responseType = '';
        }
        if (headers) {
            Object.keys(headers).forEach(function (k) {
                xhr.setRequestHeader(k, headers[k]);
            });
        }
        xhr.onload = function (ev) {
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(xhr.response);
            }
            else {
                reject(new NetworkError(xhr.status, xhr.statusText));
            }
        };
        xhr.onerror = function (e) {
            var statusText = xhr.statusText;
            if (xhr.readyState === 4 && xhr.status === 0 && statusText === '') {
                statusText = 'Network Error';
            }
            reject(new NetworkError(xhr.status, statusText));
        };
        xhr.onabort = function (ev) {
            var statusText = 'Request aborted';
            reject(new NetworkError(xhr.status, statusText));
        };
        if (data) {
            xhr.send(data);
        }
        else {
            xhr.send();
        }
    });
}
